import GlobalService from "./_GlobalService";

class PrestationGroupService extends GlobalService {
  constructor() {
    super("prestationsgroups");
  }
}

export default new PrestationGroupService();
